<div echarts [options]="chartOption"></div>